import { Component, ElementRef, ViewChild, AfterViewInit, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import QRCodeStyling, { FileExtension } from 'qr-code-styling';
import { environment } from '../../../../../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qr-generator',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatSelectModule, 
    MatFormFieldModule,
    MatIconModule
  ],
  templateUrl: './qr-generator.html',
  styleUrl: './qr-generator.scss',
})
export class QrGenerator implements AfterViewInit {
  dialogData = inject<{
    propertyId: string;
}>(MAT_DIALOG_DATA);

  @Input() propertyId: string | undefined = undefined;
  @ViewChild('canvas', { static: false }) canvas!: ElementRef;
  urlParam = '';
  data = environment.appUrl + this.urlParam;
  extension: FileExtension = 'png';
  
  private qrCode: QRCodeStyling = new QRCodeStyling({
    width: 350,
    height: 350,
    type: 'svg',
    data: this.data,
    image: '/assets/images/social_logo.png',
    margin: 15,
    dotsOptions: { 'gradient': { type: 'radial', colorStops: [{ offset: 0, color: '#0d508e' }, { offset: 1, color: '#0d508e' }] },  type: 'extra-rounded' },
    imageOptions: { crossOrigin: 'anonymous', margin: 5 }
  });


  constructor() {
    const dialogData = this.dialogData;

    // 1. Grab the ID from the dialog data
    this.propertyId = dialogData.propertyId;
    
    // 2. Build the initial data string
    const urlParam = `/property/${this.propertyId}`;
    this.data = environment.appUrl + urlParam;

    // 3. Initialize the QR class here or in ngOnInit
    this.qrCode = new QRCodeStyling({
      width: 350,
      height: 350,
      type: 'svg', // Reference type for rendering
      data: this.data,
      image: '/assets/images/social_logo.png',
      margin: 15,
      dotsOptions: { 
        type: 'extra-rounded',
        gradient: { 
          type: 'radial', 
          colorStops: [{ offset: 0, color: '#72a2d6' }, { offset: 3, color: '#0d508e' }] 
        } 
      },
      imageOptions: { crossOrigin: 'anonymous', margin: 5 }
    });
  }

  ngAfterViewInit(): void {
    this.qrCode.append(this.canvas.nativeElement);
  }

  onKey(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.data = input.value;
    this.qrCode.update({ data: this.data });
  }

  onChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.extension = select.value as FileExtension;
  }

  onMatChange(event: MatSelectChange): void {
    this.extension = event.value;
  }

  download(): void {
    this.qrCode.download({ name: 'horizinns-qr-code', extension: this.extension });
  }
}